import { encodeBearerToken, filterInstagramCookies } from '../cookies'
import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

export function splitWebBlocksRecords(data: string): string[] {
  return data
    .trim()
    .split('\n\n')
    .map((b) => b.trim())
    .filter((b) => b.length > 0)
}

export function canParseWebBlocks(data: string): boolean {
  return data.includes('Cookies Json:') || data.includes('2FA key:')
}

export function parseWebBlocks(record: string): AccountData {
  const fields: Record<string, string> = {}
  for (const raw of record.trim().split('\n')) {
    const line = raw.trim()
    if (line.startsWith('login:')) fields.login = line.slice('login:'.length).trim()
    else if (line.startsWith('password:')) fields.password = line.slice('password:'.length).trim()
    else if (line.startsWith('Email login:')) fields.email_login = line.slice('Email login:'.length).trim()
    else if (line.startsWith('Email password:')) fields.email_password = line.slice('Email password:'.length).trim()
    else if (line.startsWith('2FA key:')) fields.twofa_key = line.slice('2FA key:'.length).trim().replaceAll(' ', '')
    else if (line.startsWith('UserAgent:')) fields.user_agent = line.slice('UserAgent:'.length).trim()
    else if (line.startsWith('Cookies Json:')) fields.cookies_json = line.slice('Cookies Json:'.length).trim()
  }

  if (!fields.login || !fields.password) throw new ParseError('Missing login or password')
  if (!fields.cookies_json) throw new ParseError('Missing Cookies Json')

  let cookieObjects: Array<Record<string, string>>
  try {
    cookieObjects = JSON.parse(fields.cookies_json) as Array<Record<string, string>>
  } catch (e) {
    throw new ParseError(`Invalid JSON in Cookies Json: ${(e as Error).message}`)
  }

  const cookies = filterInstagramCookies(cookieObjects)
  if (!('sessionid' in cookies) || !('ds_user_id' in cookies)) {
    throw new ParseError('Missing required cookies: sessionid, ds_user_id')
  }

  const bearer = encodeBearerToken(cookies.sessionid, cookies.ds_user_id)
  cookies.Authorization = `Bearer ${bearer}`

  return {
    ...emptyAccount(),
    login: fields.login,
    password: fields.password,
    twofaKey: fields.twofa_key ?? '',
    userAgent: fields.user_agent ?? '',
    emailLogin: fields.email_login ?? '',
    emailPassword: fields.email_password ?? '',
    cookies,
  }
}
